/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IScaleLevel {
  Minus6 = 'minus6',
  Minus5 = 'minus5',
  Minus4 = 'minus4',
  Minus3 = 'minus3',
  Minus2 = 'minus2',
  Minus1 = 'minus1',
  Zero = 'zero',
  Plus1 = 'plus1',
  Plus2 = 'plus2',
  Plus3 = 'plus3',
  Plus4 = 'plus4',
  Plus5 = 'plus5',
  Plus6 = 'plus6',
}
